<template>

<div>
  <div class="row">
    <div class="col-lg-4" v-for="item in locations" :key="item">
      <div class="ibox light-bottom-shadow">
        <div class="ibox-title">
          <h5>{{ item }}</h5>
        </div>

        <div class="ibox-content">
          <div class="row">
            <div class="col-md-6">
              <h1 class="no-margins">{{ getAmount(item) }}</h1>
            </div>

            <div class="col-md-6 text-right">
              <b-button
                class="mr-1"
                v-if="item === 'ESTOQUE'"
                :disabled="getAmount(item) == 0"
                variant="primary"
                size='sm'
                pill
                @click="listDetailed(item, 'stock')"
              >
                Status
              </b-button>

              <b-button
                class="mr-1"
                v-if="item === 'OFICINA CREDENCIADA'"
                :disabled="getAmount(item) == 0"
                variant="primary"
                size='sm'
                pill
                @click="listDetailed(item, 'garage')"
              >
                Oficina
              </b-button>

              <b-button
                class="mr-1"
                v-if="item === 'EM POSSE DO CLIENTE' || item === 'EXTRAVIADO'"
                :disabled="getAmount(item) == 0"
                variant="primary"
                size='sm'
                pill
                @click="listDetailed(item, 'client')"
              >
                Cliente
              </b-button>

              <b-button
                :disabled="getAmount(item) == 0"
                variant="primary"
                size='sm'
                pill
                @click="listDetailed(item)"
              >
                Modelo
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-4">
      <div class="ibox light-bottom-shadow">
        <div class="ibox-title">
          <div class="d-flex justify-content-between">
            <h5>TOTAL DE RASTREADORES</h5>
            <h5>{{ totalTrackers }}</h5>
          </div>
        </div>
        <div class="ibox-content">
          <div class="no-margins row d-flex justify-content-between">
            <h4>VINCULADOS</h4>
            <h4>{{ totalLinked }}</h4>
          </div>
          <hr />
          <div class="no-margins row d-flex justify-content-between">
            <h4>NÃO VINCULADOS</h4>
            <h4>{{ totalNotLinked }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL STATUS/MODEL -->
  <div
    ref='modalStatusModel'
    id="modalStatusModel"
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalStatusModel"
    aria-hidden="true"
  >
    <div class="modal-xl modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalTitle">{{ locationSelected }}</h5>
        </div>

        <div class="modal-body">
          <div class="row d-flex justify-content-around">
            <h3>VINCULADOS: {{ totalLinkedTemp }}</h3>
            <h3>NÃO VINCULADOS: {{ totalNotLinkedTemp }}</h3>
          </div>

          <b-table
            id='tableModal'
            responsive='xl'
            bordered
            hover
            :fields="fieldsByStatusAndModel"
            :items='trackersByStatusAndModel'
            class="bg-white"
            :busy='busy'
          >
            <template v-slot:table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
              </div>
            </template>

            <template v-slot:cell(id)=value>
              <router-link
                v-if="value.item[Object.keys(value.item)[0]] !== 'TOTAL'"
                :to="{
                  name: 'listactives',
                  query: {
                    [getKeyFilter(Object.keys(value.item)[0])]: Object.keys(value.item)[0] === 'vehicle' ? value.item.vehicle.substr(0,8) : value.item.id,
                    location  : locationSelected,
                    activeType: 10
                  }
                }"
                target="_blank"
              >
                <b-button
                  size="sm"
                  variant='primary'
                  pill
                >
                  <i class="fas fa-list" />
                </b-button>
              </router-link>
            </template>
          </b-table>
        </div>

        <div class="modal-footer">
          <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL STOCK -->
  <div
    ref='modalStock'
    id="modalStock"
    class="modal fade bd-example-modal-xl"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalStock"
    aria-hidden="true"
  >
    <div class="modal-xl modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalTitle">{{ locationSelected }}</h5>
        </div>

        <div class="modal-body">
          <div class="row d-flex justify-content-around">
            <h3>VINCULADOS: {{ totalLinkedTemp }}</h3>
            <h3>NÃO VINCULADOS: {{ totalNotLinkedTemp }}</h3>
          </div>

          <hr>

          <div class="row">
            <div class="col-lg-4" v-for="(item, index) in totalByStock" :key="index">
              <div class="ibox">
                <div class="ibox-title">
                  <h5>{{ item.name }}</h5>
                </div>
                <div class="ibox-content">
                  <div class="row">
                    <div class="col-md-6">
                      <h1 class="no-margins">{{ item.amount }}</h1>
                    </div>

                    <div class="col-md-6 text-right">
                      <router-link
                        v-if="item.name !== 'SEM STATUS'"
                        :to="{
                          name: 'listactives',
                          query: {
                            status    : item.id,
                            location  : locationSelected,
                            activeType: 10
                          }
                        }"
                        target="_blank"
                      >
                        <b-button
                          size="sm"
                          variant='primary'
                          pill
                        >
                          <i class="fas fa-list" />
                        </b-button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <b-button class="mt-3" id='closeModal' data-dismiss="modal">{{ $t('close') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import { request } from '@/lib/http'
import locations from '@/config/locations'

export default {
  name: 'ReportLastPosition',
  components: {
    LoaderButton
  },
  data () {
    return {
      locations,
      amountByLocations       : [],
      totalTrackers           : 0,
      totalLinked             : 0,
      totalNotLinked          : 0,
      busy                    : false,
      fieldsByStatusAndModel  : [],
      trackersByStatusAndModel: [],
      fieldsTotalByStatus     : [],
      trackersTotalByStatus   : [],
      totalLinkedTemp         : undefined,
      totalNotLinkedTemp      : undefined,
      locationSelected        : '',
      availableStatus         : [],
      totalByStock            : []
    }
  },

  methods: {
    getAmount(location) {
      const total = this.amountByLocations.find(item => item['location'] == location)

      return total
        ? total.total
        : 0
    },

    async listDetailed(location, type = 'default') {
      this.busy             = true
      this.locationSelected = location

      type !== 'stock'
        ? $('#modalStatusModel').modal('show')
        : $('#modalStock').modal('show')

      const items = await request({
        url   : 'trackers-detailed',
        method: 'get',
        params: { location, type }
      })

      this.totalLinkedTemp    = items.linked
      this.totalNotLinkedTemp = items.notLinked

      if (type === 'stock') {
        return this.totalByStock = items.data
      }

      const mapTextFirstColumn = {
        'default': 'MODELO/STATUS',
        'garage' : 'OFICINA CREDENCIADA',
        'vehicle': 'VEÍCULO DO CLIENTE',
        'client' : 'CLIENTE/CONTRATO'
      }
      const mapInfoRow = {
        'default': 'models',
        'garage' : 'garages',
        'vehicle': 'vehicles',
        'client' : 'clients'
      }
      const mapField = {
        'default': 'model',
        'garage' : 'garage',
        'vehicle': 'vehicle',
        'client' : 'client'
      }
      const mapFieldId = {
        'default': 'modelId',
        'garage' : 'garageId',
        'vehicle': 'vehicleId',
        'client' : 'clientId'
      }

      const tempColumns = [{ key: `${mapField[type]}`, label: mapTextFirstColumn[type] }]
      const infoRows    = []
      const tempRows    = []

      // DEFINE AS COLUNAS
      for (const status of items.data) {
        const key = status.status ? status.status.replace(/\s/g, '_') : 'SEM_STATUS'

        if (!this.availableStatus.includes(key)) {
          this.availableStatus.push(key)
        }

        tempColumns.push({
          key,
          label: status.status
        })
      }
      tempColumns.push({
        key    : 'TOTAL',
        label  : 'TOTAL',
        variant: 'secondary',
        class  : 'text-center'
      })
      tempColumns.push({
        key  : 'id',
        label: '',
        class: 'text-center'
      })

      this.fieldsByStatusAndModel = tempColumns
      const itemRow = []

      // DEFINE OS MODELOS DISPONÍVEIS
      for (const item of items.data) {
        for (const value of item[mapInfoRow[type]]) {
          const hasValue = infoRows.find(temp => temp === value[mapField[type]])

          if (!hasValue) {
            itemRow.push(value)
            infoRows.push(value[mapField[type]])
          }
        }
      }

      // DEFINE AS LINHAS
      for (const row of infoRows) {
        let rowMounted      = { [mapField[type]]: row, 'TOTAL': 0, 'id': undefined }
        const [{ [mapFieldId[type]]: value }] = itemRow.filter(item => item[mapField[type]] === row)

        for (const item of items.data) {
          let amount = 0

          for (const valueItem of item[mapInfoRow[type]]) {
            if (valueItem[mapField[type]] === row) {
              amount += valueItem.amount
              rowMounted['TOTAL'] = rowMounted['TOTAL'] += valueItem.amount
              rowMounted['id']    = value
            }
          }
          rowMounted[item.status ? item.status.replace(/\s/g, '_') : 'SEM_STATUS'] = amount
        }
        tempRows.push(rowMounted)
      }

      // DEFINE A LINHA DO TOTAL
      let totalRow = { [mapField[type]]: 'TOTAL', _rowVariant: 'secondary', 'TOTAL': 0 }
      for (const total of items.data) {
        totalRow['TOTAL'] = totalRow['TOTAL'] += total.total
        totalRow[total.status ? total.status.replace(/\s/g, '_') : 'SEM_STATUS'] = total.total
      }
      tempRows.unshift(totalRow)

      this.trackersByStatusAndModel = tempRows

      this.busy = false
    },

    getKeyFilter(field) {
      if (field === 'garage') {
        return 'garageAccredited'
      }

      if (field === 'vehicle') {
        return 'board'
      }

      return field
    }
  },

  async mounted() {
    const { data, total, totalLinked, totalNotLinked } = await request({
      url   : 'trackers-by-location',
      method: 'get'
    })

    this.amountByLocations = data
    this.totalTrackers     = total
    this.totalLinked       = totalLinked
    this.totalNotLinked    = totalNotLinked

    const global = this
    $('#modalStatusModel').on('hide.bs.modal', function (event) {
      global.fieldsByStatusAndModel   = []
      global.trackersByStatusAndModel = []
    })

    $('#modalStock').on('hide.bs.modal', function (event) {
      global.fieldsTotalByStatus   = []
      global.trackersTotalByStatus = []
    })
  }
}
</script>
